import React from 'react'

const BorderedImg = ({ borderColor, radius, source, alt, children }) => {
    return (
        
        <img style={{ border: `1px solid ${borderColor}`, borderRadius: `${radius}px`, maxWidth: `100%` }}
            src={ source } 
            alt={ alt } />

    )
}

export default BorderedImg